export default "__VITE_ASSET__DYA_$3g6__"